import React, { useEffect, useState } from 'react';
import { useLanguage } from '../../contexts/LanguageContext';

const AboutArea = ({
  ST1 = "Since  2006",
  TITLE = "Welcome to Eagle Vizion",
  P1 = "Founded in 2006, Eagle Vizion engineers advanced material identification and sorting systems that redefine operational performance.",
  P2 = "We combine precision optics, NIR and hyperspectral imaging, artificial intelligence, and intelligent data platforms to detect more, sort better, and deliver actionable insight across complex material streams. From PET bottle-to-bottle recycling to MRFs, C&D, advanced polymer processing, mining, and food, our technologies transform material flows into measurable operational advantage.",
}) => {
  const { currentLanguage, translateContent } = useLanguage();
  const [translations, setTranslations] = useState({ ST1, TITLE, P1, P2 });

  useEffect(() => {
    const translateAll = async () => {
      const keys = ['ST1', 'TITLE', 'P1', 'P2'];
      const originalTexts = { ST1, TITLE, P1, P2 };

      const newTranslations = {};

      const translationPromises = keys.map(async (key) => {
        const translated = await translateContent(originalTexts[key]);
        return { key, translated };
      });

      const results = await Promise.all(translationPromises);

      results.forEach(({ key, translated }) => {
        newTranslations[key] = translated;
      });

      setTranslations(newTranslations);
    };

    translateAll();
  }, [currentLanguage, ST1, TITLE, P1, P2, translateContent]);

  return (
    <>
      <section className="about__area pt-120 pb-150">
        <div className="container">
          <div className="row">
            <div className="col-xl-6 col-lg-6">
              <div className="about__right">
                <div className="about__info pb-20">
                  <div className="section-2__wrapper mb-30">
                    <span className="st-1">{translations.ST1}</span>
                    <h5 className="section__title-sd">{translations.TITLE}</h5>
                  </div>
                  <p className="about__info-quote" style={{textAlign: "justify"}}>
                    {translations.P1}
                  </p>
                  <p className="about__info-quote" style={{textAlign: "justify"}}>
                    {translations.P2}
                  </p>
                </div>
                {/* <div className="about__list mt-40">
                  <div className="row">
                    <div className="col-xl-6">
                      <div className="about__list-item mb-30">
                        <i className="flaticon-pushcart"></i>
                        <h5 className="about__list-item-title">
                          100% Color volume for better quality
                        </h5>
                      </div>
                    </div>
                    <div className="col-xl-6">
                      <div className="about__list-item mb-30">
                        <i className="flaticon-chip"></i>
                        <h5 className="about__list-item-title">
                          Over a 1.07 bilion colors provide
                        </h5>
                      </div>
                    </div>
                  </div>
                </div> */}
                {/* <div className="about__button mt-20">
                  <Link href="/about">
                    <a className="tp-btn-d">Get Consultation</a>
                  </Link>
                </div> */}
              </div>
            </div>
            <div className="col-xl-6 col-lg-6">
              <div className="about__image">
                <div className="about__image-big">
                  <img src="assets/img/about/about_v2.png" alt="" />
                </div>
                <div className="about__image-small" >
                  <img src=" /assets/img/products/resizedPictures/QC_RMR_2.png" alt="" />
                </div>
                {/* <div className="about__image-shape">
                  <span></span>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default AboutArea;
